import { DecisionningErrorTile, FilteredCreditApplication, Loader, UnderReviewTile } from '@applyonline/shared'
import { ECreditApplicationStep, EDecision } from '@if/core/types'
import { hasMissingDocuments } from '../../../data/creditapp-selectors'
import { useTranslation } from 'react-i18next'
import DeclinedDecisionForm from '../components/DeclinedDecisionForm'
import CreditFileLockedTile from './components/CreditFileLockedTile'
import RequiredDocForDecisionForm from './components/RequiredDocForDecisionForm'

interface Props {
  creditApp: FilteredCreditApplication
}

const HardHitUnapprovedResultPage = ({ creditApp }: Props) => {
  const { t } = useTranslation()

  const hasMissingDocForCreditDecision = hasMissingDocuments(creditApp, ECreditApplicationStep.Credit)

  if (creditApp.applicant.hasLockedCreditReport) return <CreditFileLockedTile creditApp={creditApp} />

  if (creditApp.finalDecision.decision === EDecision.Error || !creditApp.applicant.hasCreditReport)
    return <DecisionningErrorTile />

  if (creditApp.finalDecision.decision === EDecision.Refused) return <DeclinedDecisionForm creditApp={creditApp} />

  if (creditApp.finalDecision.decision === EDecision.ManualRevision && !hasMissingDocForCreditDecision)
    return <UnderReviewTile />

  if (creditApp.finalDecision.decision === EDecision.ManualRevision && hasMissingDocForCreditDecision)
    return <RequiredDocForDecisionForm creditApp={creditApp} />

  return <Loader title={t('common.withYouShortly')} description={t('common.pleaseWait')} />
}

export default HardHitUnapprovedResultPage
